import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import FormHelperText from '@material-ui/core/FormHelperText';

interface Props {
  displayText: string;
  href: string;
  open: boolean;
  isEditing?: boolean;
  onClose: () => void;
  onDisplayTextChange: (e: any) => void;
  onHrefChange: (e: any) => void;
  onRemoveLink: () => void;
  onSave: () => void;
}

function LinkEditDialog({
  displayText,
  href,
  open,
  isEditing,
  onClose,
  onDisplayTextChange,
  onHrefChange,
  onRemoveLink,
  onSave,
}: Props) {
  const classes = useStyles();

  return (
    <Dialog open={open} onClose={onClose} aria-labelledby="form-dialog-title">
      <div className={classes.titleBar}>
        <DialogTitle id="form-dialog-title">{isEditing ? 'Edit' : 'Add'} Link</DialogTitle>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent>
        <TextField
          value={displayText}
          autoFocus
          margin="dense"
          label="Display text"
          fullWidth
          variant="outlined"
          onChange={onDisplayTextChange}
          helperText={
            !displayText && (
              <FormHelperText error className={classes.helperText}>
                Display text cannot be empty
              </FormHelperText>
            )
          }
        />
        <TextField
          value={href}
          margin="dense"
          label="Link"
          fullWidth
          variant="outlined"
          onChange={onHrefChange}
          helperText={
            !href && (
              <FormHelperText error className={classes.helperText}>
                Link cannot be empty
              </FormHelperText>
            )
          }
        />
      </DialogContent>
      <DialogActions>
        {isEditing && (
          <Button onClick={onRemoveLink} color="primary">
            Remove Link
          </Button>
        )}
        <Button onClick={onSave} color="primary" disabled={!displayText || !href}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  titleBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  closeButton: {
    marginRight: theme.spacing(0.5),
  },
  helperText: {
    marginLeft: -theme.spacing(1.5),
  },
}));

export default LinkEditDialog;
